import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Flame, Target } from "lucide-react";

const BAR_START = { width: 0 };
const SPRING = { type: "spring", stiffness: 120, damping: 20 };
const POP = { scale: 1.2 };
const SETTLE = { scale: 1 };

const STYLE = { gentle: "Gentle", balanced: "Balanced", direct: "Firm" };
const fmt = (hhmm) => { const [h, m] = hhmm.split(":").map(Number); return `${h % 12 || 12}:${String(m).padStart(2, "0")}${h < 12 ? " am" : " pm"}`; };

export function Momentum({ m }) {
  const pct = m.total ? Math.round((100 * m.done) / m.total) : 0;
  return (
    <div className="card p-4 sm:p-5" data-testid="momentum-bar">
      <div className="flex items-center justify-between gap-3">
        <span className="eyebrow">Today's progress</span>
        <motion.span key={m.done} initial={POP} animate={SETTLE} className="text-sm font-semibold text-[#2D2926]" data-testid="momentum-done">{m.done} of {m.total} done</motion.span>
      </div>
      <div className="h-2 mt-3 rounded-full bg-[#EDE7DD] overflow-hidden">
        <motion.div className="h-full bg-[#4F6B55] rounded-full" initial={BAR_START} animate={{ width: `${pct}%` }} transition={SPRING} />
      </div>
      {(m.mission || m.streak > 0 || m.week_streak > 0) && <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-3 text-xs text-[#635E59]">
        {m.mission && <span className="inline-flex items-center gap-1" data-testid="momentum-mission"><Target className="h-3.5 w-3.5" />Mission {m.mission.count}/{m.mission.target}</span>}
        {m.streak > 0 && <span className="inline-flex items-center gap-1" data-testid="momentum-streak"><Flame className="h-3.5 w-3.5 text-[#C86D51]" />{m.streak}-day streak</span>}
        {m.week_streak > 0 && <span className="inline-flex items-center gap-1 font-semibold text-[#4F6B55]" data-testid="momentum-week-streak"><Flame className="h-3.5 w-3.5" />{m.week_streak}-week streak</span>}
      </div>}
    </div>
  );
}

export function Header({ clock, day, style, accent, actions }) {
  const date = new Date(`${clock.personal_day}T12:00`).toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" });
  return (
    <header className="rise" data-testid="today-header">
      <div className="flex flex-wrap items-end justify-between gap-x-4 gap-y-3">
        <div className="min-w-0">
          <p className="eyebrow" data-testid="today-date">{date} · {fmt(clock.time)}</p>
          <h1 className="font-display text-4xl sm:text-5xl tracking-tight text-[#2D2926] mt-1" data-testid="today-title">Today</h1>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          {day && <span data-testid="today-day-type" className="h-11 inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider px-4 rounded-full border border-stone-300 text-stone-700 bg-white">
            <span className="h-1.5 w-1.5 rounded-full" style={{ background: accent }} />{day.shape_label || "Today"}</span>}
          <Link to="/you" data-testid="coach-style-chip" className="h-11 px-4 rounded-full border border-stone-300 bg-white text-xs font-semibold text-[#2D2926] inline-flex items-center chip hover:bg-stone-50">{STYLE[style] || "Balanced"} coach</Link>
        </div>
      </div>
      {actions && <div className="mt-4">{actions}</div>}
      {day?.note && <p className="font-display text-lg sm:text-xl leading-snug tracking-tight mt-4 text-[#45403B] max-w-2xl" data-testid="today-note">{day.note.replace(/^Swapped in something different\. /, "")}</p>}
    </header>
  );
}
